import React, { Component } from "react";

import { DKLabel,DKLine,DKButton } from "deskera-ui-library";
import {
  COLUMN_CODE,
  TableManger,
  TABLES,
} from "../../../managers/TableManger";
import Table from "../../../services/table";
import Moment from 'react-moment';
import moment from 'moment';
import i18next from "i18next";
import PermissionUtils, { ACTION, MODULE } from "../../user-permissions/PermissionUtils";
import { extractTextFromHTML, stringSanitizer } from "../../../managers/common/CommonUtil";

class RightPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dealId: this.props.dealId,
      dealDetails: this.props.dealDetails,
      note:
      '',//Note: Will use in future,  //this.props.dealDetails.note && this.props.dealDetails.note !== undefined && this.props.dealDetails.note !="" && this.props.dealDetails.note.length !=0 ? this.props.dealDetails.note[this.props.dealDetails.note.length-1].note : "",
    noteList : this.props.dealDetails.note && this.props.dealDetails.note !== undefined && this.props.dealDetails.note !="" ?  this.props.dealDetails.note: [],
    selectedNote: null//Note: Will use in future,  //this.props.dealDetails.note && this.props.dealDetails.note !== undefined && this.props.dealDetails.note !="" && this.props.dealDetails.note.length !=0 ? this.props.dealDetails.note[this.props.dealDetails.note.length-1] : null
    };
    this.noteText = this.props.dealDetails.note;
    this.timer = null;
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      dealDetails: nextProps.dealDetails,
      note: '',
      noteList: nextProps.dealDetails.note || []
    });
  }

  render() {
    return this.getRightPanel();
  }
  onNoteChange = (e) => {
    this.setState({ 
      note: e.target.value  
     });
  };
  componentDidUpdate(prevProps, prevState) {
    // if (prevState.dealDetails.note !== this.state.note) {
    //   this.handleCheck();
    // }
  }
  handleCheck = () => {
    // clearTimeout(this.timer);
    // this.timer = setTimeout(() => {
    //   this.saveNote();
    // }, 2000);
  };
  saveNote = () => {
    const dealNoteColumnId = TableManger.getColumnId(
      TABLES.CANDIDATE,
      COLUMN_CODE.CANDIDATE.NOTE
    );
    const stageColumnId = TableManger.getColumnId(
      TABLES.CANDIDATE,
      COLUMN_CODE.CANDIDATE.JOB_STAGE_ID
    );
    let dealTableId = TableManger.getTableId(TABLES.CANDIDATE);
    let data = {
      [dealNoteColumnId]: this.state.noteList,
      [stageColumnId]: [this.state.dealDetails.stage_id],
    };
    Table.updateRecord(data, this.state.dealId, dealTableId).then((data) => {});
  };

  getRightPanel() {
    return (
      <div className="column mr-l" style={{ minWidth: 280, maxWidth: 280 }}>
        {this.getNotes()}
        {this.getLogs()}
      </div>
    );
  }

  getNotes() {
    return (
        <>
      <div className="bg-deskera-secondary border-m border-radius-s ml-l parent-width border-box">
        <div className="row">
          <div className="column">
            <DKLabel text="Notes" className="fw-m p-h-m pt-m" />
          </div>
        </div>
        <textarea
          readOnly={!PermissionUtils.hasAccess(MODULE.CANDIDATE,[ACTION.EDIT])}
          rows="10"
          className="p-s note-textarea app-font"
          name="Note"
          placeholder="Add note here"
          required
          value={this.state.note}
          onChange={(e) => this.onNoteChange(e)}
          style={{ border: "none", width: "90%", resize: "none" }}
        />

      </div>
      {PermissionUtils.hasAccess(MODULE.CANDIDATE,[ACTION.EDIT]) &&
        <DKButton title={i18next.t("NOTE_SAVE")} className="row border-radius-m text-wrap-none bg-app text-white fw-m mt-l ml-l" onClick={() => {
        this.createNote()
      }} />}
      </>
    );
  }
  createNote = () => {
    this.saveNoteList(true)
    this.setState({
        selectedNote: null
    });
  }
  saveNoteList = (isAutoSave) => {
    if(this.state.note && this.state.note.trim() !='') {
      const note = extractTextFromHTML(stringSanitizer(this.state.note))
        if(this.state.selectedNote){
            this.state.noteList.forEach(element=>{
                if(element.id == this.state.selectedNote.id) {
                    element['updatedAt']= moment().toISOString();
                    element['note']= note;
                    this.state.selectedNote.note = note;
                }
            })
        } else {
            let newObj = {
                id: this.state.noteList.length,
                note: note,
                createdAt:moment().toISOString(),
                updatedAt: moment().toISOString()
            }
            this.state.noteList.push(newObj);
            this.state.selectedNote = newObj;
        }


        this.saveNote();
        this.setState({
            note: isAutoSave ? "":extractTextFromHTML(stringSanitizer(this.state.selectedNote.note)),
            noteList: this.state.noteList
        });
    } else {
        this.setState({
            note:''
        });
    }


  }
  getLogs() {
    return (
      <div className=" bg-gray1 border-m border-radius-s p-l ml-l mt-l parent-width border-box">
        <DKLabel text="Logs" className="fw-m" />
        {this.state.noteList.length == 0 &&<DKLabel text="No logs created yet" className="mt-m text-dark-gray" />}
        {this.getNotesList()}
      </div>
    );
  }
  getNotesList() {
    const start = moment();
    const calendarStrings = {
        lastDay : '[Yesterday at] LT',
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        lastWeek : '[last] dddd [at] LT',
        nextWeek : 'dddd [at] LT',
        sameElse : 'L'
    };
    let noteList = this.state.noteList.sort(function(a,b){
      return new Date(b.createdAt) - new Date(a.createdAt);
    });
      let list = noteList.map(ele=>{
            return (
                <div key={ele.createdAt} className="bg-deskera-secondary border-m border-radius-s parent-width border-box mt-m cursor-hand" 
                onClick={()=>{
                  // Note: Will use in future
                    // this.state.selectedNote = ele;
                    // this.setState({
                    //      note: ele.note
                    // })
                }}>
                <div className="m-l">
                <Moment className="d-flex fw-m" date={ele.createdAt} calendar={calendarStrings}/>
                <DKLabel text={extractTextFromHTML(stringSanitizer(ele.note))} className="mt-m text-dark-gray" />
                </div>
                </div>
            )
      })
      return (
          <>
            {list}
          </>
      )
  }
}

export default RightPanel;
